import {transmission, USER_ROOT, WEB_METHODS} from '../../network/index'
import VueCookies from 'vue-cookies'
import Util from '@/utils/utils'
import swal from 'sweetalert'

const BASE_URL = `${window.location.protocol}//${window.location.host}`
// TODO 개발
// eslint-disable-next-line no-unused-vars
const dummyUser = {
  success: true,
  code: '0000',
  msg: '정상',
  // data: {
  //   userKey: 3232,
  //   userId: 'taeuk_test1',
  //   userName: '테스터',
  //   clientCd: 'ezn',
  //   clientNo: null,
  //   disabled: false,
  //   authorities: null,
  //   attributes: null,
  //   name: '테스터',
  //   profileAtchNo: 604166,
  //   profileAtchFileName: '62dbcd19-b15c-4845-9095-c14f0cc4d423'
  // }
  data: {
    userKey: 590,
    userId: 'taeuk_test1',
    userName: '테스터',
    clientCd: 'slamdunk',
    clientNo: null,
    disabled: false,
    authorities: null,
    attributes: null,
    name: '테스터',
    profileAtchNo: 604166,
    profileAtchFileName: '62dbcd19-b15c-4845-9095-c14f0cc4d423',
    memberGb: "01",
    changePasswordRequired: false
  }
  // data: {
  //   userKey: 409,
  //   userId: 'dms_talk5',
  //   userName: '테스터',
  //   clientCd: 'samsungfire',
  //   clientNo: null,
  //   disabled: false,
  //   authorities: null,
  //   attributes: null,
  //   name: '테스터',
  //   profileAtchNo: 3
  // }
}

const AUTH_USER = () => {
  return {
    userKey: '',
    userId: '',
    authorities: [],
    isReadable: false,
    isWritable: false
  }
}

const state = {
  info: {},
  authUser: {
    userKey: '',
  },
  token: '',
  denyCode: '',
  globalErrorStatus: null,
  anifitProUrl: '',
  guideNo: null,
  memberGb: null,
  baseURL: BASE_URL,
}

const mutations = {
  initMyInfo (state) {
    state.authUser = AUTH_USER()
  },
  setUser: (state, userRes) => {
    state.authUser = userRes
    VueCookies.set('dms-clientCd', userRes.clientCd, '365d')
    state.authUser.authorities = []
  },
  setAnifitProUrl (state, payload) {
    state.anifitProUrl = payload
  },
  setProfileAtchNo (state, payload) {
    state.authUser.profileAtchNo = payload
  },
  setProfileAtchFileName (state, payload) {
    state.authUser.profileAtchFileName = payload
  },
  setGuideNo (state, payload) {
    state.guideNo = payload
  },
  setDenyCode (state, payload) {
    state.denyCode = payload
  },
  setGlobalErrorStatus (state, payload) {
    state.globalErrorStatus = payload
  },
  setMemberGb (state, payload) {
    state.memberGb = payload
  }
}

const actions = {
  getUserGuideImageNumber ({commit, state}) {
    if (state.guideNo === null) {
      transmission(true, WEB_METHODS.GET, `${USER_ROOT}/member/user-guide-img-no`)
          .then(res => {
            if (res.success) commit('setGuideNo', res.data)
            else commit('setGuideNo', 0)
          })
          .catch(() => {
            commit('setGuideNo', 0)
          })
    }
  },
  getAnifitProUrl ({commit, state}) {
    let url = state.anifitProUrl
    if (!url) {
      transmission(false, WEB_METHODS.GET, '/anifitpro-url', null)
          .then(res => {
            if (res.success) {
              // console.log('getAnifit : ', res)
              commit('setAnifitProUrl', res.data)
            }
          })
    }
  },
  // eslint-disable-next-line no-unused-vars
  getToken: async function ({commit, state, dispatch}) {
    if (process.env.NODE_ENV === 'production') {
      await transmission(false, WEB_METHODS.GET, '/tokens', null)
          .then(({ success, data, code })=> {
            if (success) {
              VueCookies.set('dms-user-token', data.token, 0)
              Util.Common.setLocalStorage('expireSessionTime', data.expireSessionTime)
            }
            else {
              state.denyCode = code
              VueCookies.remove('dms-user-token')

              switch (code) {
                case '9499':   //미인증
                  dispatch('logout')
                  break;
                case '9401':   //인증되지 않은 사용자
                  window.location.href = BASE_URL
                  break
                case '9777':   //중복로그인
                  swal({
                    title: '안내', text: '다른 곳에서 로그인이 되었습니다. 로그인페이지로 이동합니다.', buttons: {ok: '확인'}
                  }).then(() => {
                    dispatch('logout')
                  })
                  break;
                default:
                  throw new Error('response code is null');
              }
           }
          })
    } else {
      // TODO 개발
      VueCookies.set('dms-user-token','eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImhtLWp3ay1rZXktaWQifQ.eyJ1c2VyX3R5cGUiOiJkbXMtdXNlciIsImNsaWVudF9jZCI6Indob3lvdW1pbmQiLCJ1c2VyX2lkIjoia2Fla2FlMSIsInVzZXJfbmFtZSI6IjE4MDUiLCJzY29wZSI6WyJyZWFkIiwid3JpdGUiXSwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo4MDA1L2F1dGgiLCJ1c2VyX2tleSI6MTgwNSwiZXhwIjoxNzQzNDY2NzQ1LCJhdXRob3JpdGllcyI6WyJST0xFX0RNU19VU0VSIl0sImp0aSI6ImM5OTk5NGI2LTc4ZjEtNGVhYS1hZjdlLTQ3YTY0OTA4NWI5OCIsImNsaWVudF9pZCI6ImRtcy11c2VyIn0.lCNNohLr4y9PI9zu2hjsb8-MpnrfKZ_MOKXKZpJZeoC8w3L5_qwWNTFTj9uE5SJuBd-uTyAiyC6EjhTiY2F2atUftqVZUVfMW0095BBkKsbQe3n1E_xMSKJmrjb8Ghv55lGvBOdi5uxisNdU7iyBv-3oM88_aagx7d51TAOvQH2bPGbUym6P9iIFnfnzA2r8eq5vjm5uX4m5tmXaXrnQlk-h1FLiFBzyZCqW67OcKs0F50rx3PBrmbQmg2z0cTh1vwg-EZeDY9mLnPgNzYeSPwA3sV-4Up-9NpNbuH8PlVfKMSCs0iLhw80Fv4xQ89LUyFZ4kiBYPP68NkoJZ1Lptg', 0);
      Util.Common.setLocalStorage('expireSessionTime', 1935412333900)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getUserInfo ({commit, dispatch}) {
    if (process.env.NODE_ENV === 'development') {
      let userRes = dummyUser
      commit('setUser', userRes.data)
    } else {
      // TODO 배포용
      await transmission(false, WEB_METHODS.GET, '/tokens/user', null)
          .then(res => {
            if (res.success) {
              let data = res.data
              window.dataLayer.push({
                user_key: data.userKey,
                client_cd: data.clientCd
              })
              commit('setUser', data)
            } else {
              // TODO 개발
              VueCookies.remove('dms-user-token')
              window.location.href = '/com-error'
              // dispatch('logout')
            }
          })
    }

    // TODO 개발
    // let userRes = dummyUser
    // commit('setUser', userRes.data)
  },
  // eslint-disable-next-line no-unused-vars
  async updateProfileAtchNo ({commit}, payload) {
    return transmission(false, WEB_METHODS.PUT, '/apis/v1/user/update-profile', payload)
  },
  // eslint-disable-next-line no-unused-vars
  async logout ({commit}, payload) {
    if (VueCookies.isKey('dms-user-token')) VueCookies.remove('dms-user-token')
    if (VueCookies.isKey('dms-duplicate-user')) VueCookies.remove('dms-duplicate-user')
    if (payload === "9777") {
      swal({
        title: '안내', text: '다른 곳에서 로그인이 되었습니다. 로그인페이지로 이동합니다.', buttons: {ok: '확인'}
      })
      .then(() => {
        window.location.href = '/user/logout'
      })
    }
    else {
      window.location.href = '/user/logout'
    }
  }
}

const getters = {
  anifitProUrl (state) {
    return state.anifitProUrl
  },
  userKey (state) {
    return state.authUser.userKey
  },
  userId (state) {
    return state.authUser.userId
  },
  clientCd (state) {
    return state.authUser.clientCd
  },
  userName (state) {
    return state.authUser.userName
  },
  profileAtchNo (state) {
    return state.authUser.profileAtchNo
  },
  profileAtchFileName (state) {
    return state.authUser.profileAtchFileName
  },
  guideNo (state) {
    return state.guideNo
  },
  denyCode (state) {
    return state.denyCode
  },
  globalErrorStatus (state) {
    return state.globalErrorStatus
  },
  changePasswordRequired (state) {
    return state.authUser.changePasswordRequired
  },
  memberGb (state) {
    return state.authUser.memberGb
  }
}

export default { state, mutations, actions, getters }
